import React from 'react';

const SkipToContent = () => {
  return (
    <>
      <a href="#main-content" className="skip-to-content">
        Saltar al contenido principal
      </a>
      <a href="#navigation" className="skip-to-content">
        Ir a navegación
      </a>
    </>
  );
};

export default SkipToContent;
